import React, {Component} from 'react';
import {connect} from 'react-redux';
import {get} from 'lodash';
import {applyFilter,
  updateChipFilter,
  searchDriverVehicle
} from '../libraryFilterActions';
import ChipsFilter from './ChipsFilter';

export class MobileChipsFilter extends Component {
  updateChipFilter = chips => {
    this.props.updateChipFilter(chips);
    this.applyFilter({chipsFilter: chips});
  }
  
  applyFilter = filters => {
    const {
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      constrainedFilters,
      mediaId,
      startTime,
      endTime
    } = this.props.selectedFilters;

    const {chipsFilter} = this.props;

    this.props.applyFilter({
      groupsFilter, constrainedFilters, terminalsFilter, oerTypeFilter, chipsFilter, mediaId, startTime, endTime, ...filters
    });
  }

  render() {
    return (
      <ChipsFilter
        searchDriverVehicle={this.props.searchDriverVehicle}
        updateChipFilter={this.updateChipFilter}
        driversVehiclesList={this.props.driversVehiclesList}
        chipsFilter={this.props.chipsFilter}
        isLoading={this.props.isLoading}
      />
    );
  }
}

function mapStateToProps(state) {
  const {libraryFilters, customer} = state;
  const chipsFilter = get(libraryFilters, 'selectedFilters.chipsFilter');
  const selectedFilters = get(libraryFilters, 'selectedFilters');

  return {
    customer,
    ...libraryFilters,
    selectedFilters,
    chipsFilter
  };
}

const mapDispatchToProps = dispatch => ({
  searchDriverVehicle: params => dispatch(searchDriverVehicle(params)),
  updateChipFilter: chips => dispatch(updateChipFilter(chips)),
  applyFilter: filters => dispatch(applyFilter(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileChipsFilter);
